<template>
  <AdminContainer>
    <div class="wrapper-container">
      <div class="container-widget-header">
        <h3>AFFILIATE PROGRAM</h3>
        <div class="call-actions">
          <button class="btn-success" @click="addNew()">
            <img src="@/assets/images/icons/plus.svg" /> CREATE AFFILIATE
          </button>
          <button class="btn-success" @click="show_message_form = true">
            SEND MESSAGE
          </button>
        </div>
      </div>
      <div class="body-widget">
        <div class="table-widget">
          <table>
            <tr>
              <th>Title</th>
              <th>Image</th>
              <th>Link</th>
              <th></th>
            </tr>
            <tr v-for="(item, index) in affiliate_data" :key="index">
              <td>{{ item.title }}</td>
              <td>
                <img class="affiliate-image" :src="$store.state.ASSETS_BASE_URL +
                  'assets/uploaded/' +
                  item.image
                  " />
              </td>
              <td>{{ item.link }}</td>
              <td>
                <dropdown-menu v-model="item.is_menu_open" :right="false" :hover="false" :interactive="false"
                  class="shop-menu">
                  <button class="dropdown-toggle">
                    <img src="@/assets/images/icons/menu.svg" />
                  </button>
                  <div slot="dropdown" class="drop-down-menu">
                    <a class="dropdown-item" @click.prevent="viewItem(item)">
                      <span class="fa fa-eye"></span> View
                    </a>
                    <a class="dropdown-item" @click.prevent="editItem(item)">
                      <img src="@/assets/images/icons/edit.svg" /> Edit
                    </a>
                    <a class="dropdown-item" @click.prevent="deleteItem(item)">
                      <img src="@/assets/images/icons/trash.svg" /> Delete
                    </a>
                  </div>
                </dropdown-menu>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <!-- Add Modal -->
      <div class="overlay" v-if="show_affiliate_form">
        <div class="form-widget">
          <div class="header">
            <h3 v-if="!form.id">Add new affiliate item</h3>
            <h3 v-else>Update affiliate item</h3>
          </div>
          <div class="body">
            <div class="input-group">
              <label>Title</label>
              <div class="input-widget">
                <input type="text" v-model="form.title" class="bg-cagura-form-control" />
              </div>
            </div>
            <div class="input-group">
              <label>Content</label>
              <div class="input-widget">
                <textarea type="text" v-model="form.content" class="bg-cagura-textarea-form-control"></textarea>
              </div>
            </div>
            <div class="input-group">
              <label>Image</label>
              <div class="input-widget">
                <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
                  location="assets/uploaded/" :url="$store.state.SITE_ASSETS_BASE_URL"
                  :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.main_image"
                  @onFileSelected="onAffiliateImageSelected">
                  <div class="image-upload-widget">Choose Image to upload</div>
                </upload-trigger>
              </div>
            </div>
            <div class="input-group">
              <label>Link</label>
              <div class="input-widget">
                <input type="text" v-model="form.link" class="bg-cagura-form-control" />
              </div>
            </div>
            <div class="input-group">
              <label>Start Date</label>
              <div class="input-widget">
                <a-date-picker v-model="start_date" size="large" @change="onChangeStartDate" />
              </div>
            </div>
            <div class="input-group">
              <label>End Date</label>
              <div class="input-widget">
                <a-date-picker v-model="end_date" size="large" @change="onChangeEndDate" />
              </div>
            </div>
            <div class="input-group">
              <label>Win Price(Frw)</label>
              <div class="input-widget">
                <input type="text" v-model="form.win_price" class="bg-cagura-form-control" />
              </div>
            </div>
            <div class="input-group">
              <label>Middle Price Win(Frw)</label>
              <div class="input-widget">
                <input type="text" v-model="form.middle_price" class="bg-cagura-form-control" />
              </div>
            </div>
            <div class="input-group">
              <label>Needed user number</label>
              <div class="input-widget">
                <input type="number" v-model="form.needed_user" class="bg-cagura-form-control" />
              </div>
            </div>
            <div class="input-group">
              <label>Middle user needed number</label>
              <div class="input-widget">
                <input type="number" v-model="form.middle_needed_user" class="bg-cagura-form-control" />
              </div>
            </div>
          </div>
          <div class="footer">
            <c-button :loading="loading" @click="submitForm()" class="btn-success">Save</c-button>
            <button @click="show_affiliate_form = false" class="btn-default">
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div class="overlay" v-if="show_message_form">
        <div class="form-widget">
          <div class="header">
            <h3>Send Message</h3>
          </div>
          <div class="body">
            <div class="input-group">
              <label>Subject</label>
              <div class="input-widget">
                <input type="text" class="bg-cagura-form-control" v-model="subject" />
              </div>
            </div>
            <div class="input-group">
              <label>Message</label>
              <div class="input-widget">
                <textarea type="text" class="bg-cagura-textarea-form-control" v-model="message"></textarea>
              </div>
            </div>
          </div>
          <div class="footer">
            <c-button :loading="send_loading" @click="sendMessage()" class="btn-success">Send</c-button>
            <button @click="show_message_form = false" class="btn-default">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </AdminContainer>
</template>

<script>
export default {
  components: {},
  data: () => ({
    menu: false,
    loading: false,
    form: {
      id: null,
      title: "",
      content: "",
      main_image: "",
      link: "",
      start_date: "",
      end_date: "",
      win_price: "",
      middle_price: "",
      needed_user: 0,
      middle_needed_user: 0,
    },
    start_date: "",
    end_date: "",
    show_affiliate_form: false,
    affiliate_data: [],
    show_message_form: false,
    message: "",
    subject: "",
    send_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getAffiliateItem();
  },
  methods: {
    sendMessage() {
      let vm = this;
      if (vm.message.length > 50) {
        vm.send_loading = true;
        vm.$store
          .dispatch("AFFILIATE_SEND_MESSAGE", {
            message: vm.message,
            subject: vm.subject,
          })
          .then((response) => {
            vm.send_loading = false;
            vm.show_message_form = false;
            vm.message = "";
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.send_loading = false;
            console.error("AFFILIATE_MESSAGE", { response });
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      } else {
        vm.$notify({
          group: "status",
          type: "warn",
          title: "OOPS!!!",
          text: "Type something important....",
        });
      }
    },
    onChangeEndDate(date, dateString) {
      let vm = this;
      vm.form.end_date = dateString;
    },
    onChangeStartDate(date, dateString) {
      let vm = this;
      vm.form.start_date = dateString;
    },
    viewItem(item) {
      let vm = this;
      vm.$router.push({ path: `/affiliate/view/${item.id}` });
    },
    confirmDelete(id) {
      let vm = this;
      vm.$store
        .dispatch("AFFILIATE_DELETE_ITEM", { id: id })
        .then((response) => {
          vm.getAffiliateItem();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          console.error("AFFILIATE_DELETE_ITEM", { response });
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    deleteItem(item) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.confirmDelete(item.id);
          }
        },
      });
    },
    editItem(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.title = item.title;
      vm.form.content = item.content;
      vm.form.main_image = item.image;
      vm.form.link = item.link;
      vm.form.start_date = item.start_date;
      vm.form.end_date = item.end_date;
      vm.start_date = vm.moment(item.start_date);
      vm.end_date = vm.moment(item.end_date);
      vm.form.win_price = item.win_price;
      vm.form.middle_price = item.middle_win_price;
      vm.form.needed_user = item.views_needed;
      vm.form.middle_needed_user = item.middle_views_needed;
      vm.show_affiliate_form = true;
    },
    getAffiliateItem() {
      let vm = this;
      vm.$store
        .dispatch("AFFILIATE_GET_ITEMS")
        .then((response) => {
          vm.affiliate_data = response.data.return.map((item) => {
            vm.$store.state.eventBus.$set(item, "is_menu_open", false);
            return item;
          });
        })
        .catch(({ response }) => {
          console.log("AFFILIATE_GET_ITEMS", { error });
        });
    },
    submitForm() {
      let vm = this;
      vm.loading = true;
      if (!vm.form.id) {
        vm.$store
          .dispatch("AFFILIATE_ADD_ITEM", vm.form)
          .then((response) => {
            vm.loading = false;
            vm.getAffiliateItem();
            vm.show_affiliate_form = false;
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
            console.log("AFFILIATE_ADD_ITEM", { error });
          });
      } else {
        vm.$store
          .dispatch("AFFILIATE_UPDATE_ITEM", vm.form)
          .then((response) => {
            vm.loading = false;
            vm.getAffiliateItem();
            vm.show_affiliate_form = false;
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
            console.log("AFFILIATE_UPDATE_ITEM", { error });
          });
      }
    },
    addNew() {
      let vm = this;
      vm.show_affiliate_form = true;
      vm.form = {
        id: null,
        title: "",
        content: "",
        main_image: "",
        link: "",
        start_date: "",
        end_date: "",
        win_price: "",
        middle_price: "",
        needed_user: 0,
        middle_needed_user: 0,
      };
    },
    onAffiliateImageSelected(file) {
      let vm = this;
      vm.form.main_image = file;
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper-container {
  display: flex;
  flex-direction: column;

  .container-widget-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;

    .call-actions {
      display: flex;

      button {
        margin-left: 20px;
      }
    }
  }

  .body-widget {
    height: calc(100vh - 122px);
    overflow-y: auto;

    .table-widget {
      width: 100%;
      padding: 0px 10px;

      table {
        width: 100%;

        th {
          height: 45px;
          background: #ddd;
          border: 1px solid #fff;
          padding: 15px;
        }

        td {
          border: 1px solid #ddd;
          padding: 15px;

          .shop-menu {
            position: relative;
          }

          .affiliate-image {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }

  .overlay {
    display: flex;
    justify-content: center;
    padding-top: 80px;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    align-items: unset;

    .form-widget {
      height: 600px;
      width: 400px;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 5px;
      display: flex;
      flex-direction: column;

      .header {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 15px;
        border-bottom: 1px solid #ccc;

        h3 {
          margin: 0px;
        }
      }

      .body {
        height: calc(100% - 120px);
        overflow-y: auto;
        padding: 15px;
      }

      .footer {
        background: rgb(250, 250, 250);
        border-top: 1px solid #ccc;
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 15px;

        button {
          margin-right: 20px;
        }
      }
    }
  }

  .on-fly-options {
    position: fixed;
    bottom: 20px;
    right: 20px;

    .btn-cycle {
      height: 50px !important;
      width: 50px !important;
      min-width: 50px !important;
      border-radius: 50%;
      font-size: 29px;
      background: #fff;
      box-shadow: 0px 0px 6px #000;
    }
  }
}
</style>
